import { MEDIA_COMPONENT_STATE_LABELS, type MediaComponentState, type MediaComponentStatus } from '@lia/contracts';
import { StatusBadge, type StatusTone } from '../primitives/badge.js';

// UAT-54 (setter §09.7–§09.10): media / language components of a project with their real state. «Configurado» is
// always «sin verificar» (real quality is a Phase 0 check); unavailable and degraded components are flagged.

const TONE: Record<MediaComponentState, StatusTone> = { configured: 'info', degraded: 'warning', unavailable: 'danger', disabled: 'neutral' };

export function MediaComponentStateBadge({ state }: { state: MediaComponentState }) {
  return <StatusBadge tone={TONE[state]}>{MEDIA_COMPONENT_STATE_LABELS[state]}</StatusBadge>;
}

const CHANNEL_LABEL = { whatsapp: 'WhatsApp', voice: 'Llamadas' } as const;

export interface MediaCapabilityListProps {
  components: readonly MediaComponentStatus[];
}

/** One row per component: label, channel, spec reference, state badge and what the AI does meanwhile. */
export function MediaCapabilityList({ components }: MediaCapabilityListProps) {
  if (!components.length) return <p className="text-body text-text-secondary">Sin componentes que mostrar.</p>;
  return (
    <ul className="grid gap-2" aria-label="Componentes de medios e idioma">
      {components.map((c) => (
        <li key={c.key} className="rounded-card border border-border-subtle p-3" aria-label={`${c.label}: ${MEDIA_COMPONENT_STATE_LABELS[c.state]}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-body font-medium text-text-primary">
              {c.label}
              <span className="ml-2 text-meta font-normal text-text-secondary">
                {CHANNEL_LABEL[c.channel]} · {c.specRef}
              </span>
            </p>
            <MediaComponentStateBadge state={c.state} />
          </div>
          <p className="mt-1 text-meta text-text-secondary">{c.detail}</p>
        </li>
      ))}
    </ul>
  );
}
